import React from 'react';
import { makeStyles } from "@material-ui/core";

export interface ITitledContainer {
    title: string;
    titleButtons?: React.ReactNode;
    children: React.ReactNode;
}

const useStyles = makeStyles({

    container: {
        border: '1px solid #ededed',
        borderRadius: '1rem',
      },
      controls: {
        borderBottom: '1px solid #ededed',
        padding: '.5rem 1rem',
        display: 'flex',
        alignItems: "center",
    
        '& > p': {
            flex: "1 1 auto",
            margin: 0,
            fontSize: '1rem',
            fontWeight: 400,
            color: '#737fa4',
        }
      },
      buttons: {
        flex: "0 0 auto",
        display: 'flex',
        justifyContent: 'space-between',
      },
})


const TitledContainer = (props: ITitledContainer) => {

    const { title, titleButtons, children } = props;
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.controls}>
                <p>{title}</p>
                {
                    <div className={classes.buttons}>
                        { titleButtons }
                    </div>
                }
            </div>
            <div>{children}</div>
        </div>
    )
}



export default TitledContainer;